import { SET_EVENTS, SET_EVENTS_LOADING } from '../types'

const reducer = (state, action) => {
  switch (action.type) {
    case SET_EVENTS:
      return {
        ...state,
        events: action.payload,
        eventsLoaded: true,
        eventsLoading: false
      }
    case SET_EVENTS_LOADING:
      return {
        ...state,
        eventsLoading: action.payload,
        eventsLoaded: !action.payload
      }
    default:
      return state
  }
}

export default reducer
